export type TenantFeature =
  /** Landing Page - Protection section for upselling quotes */
  | 'protection'
  /** Landing Page - model number location slider */
  | 'modelNumberLocation'
  /** Landing Page - Prompt user to call or use product documentation */
  | 'callUsSupport'
  /** Footer Layout - Display appliance care term and conditions in links   */
  | 'applianceCareTermAndConditions'
  /** Error Page - Prompt user to call the contact center */
  | 'errorPageCallUs'
  /** Confirmation Page - Access Product Details Button */
  | 'productDetails'
  /** Loading Spinner - phone number */
  | 'loadingPhoneUs';

export type TenantFeatures = Record<TenantFeature, boolean>;

export type TenantFeatureOverrides = Partial<TenantFeatures>;

export const defaultTenantFeatures: TenantFeatures = {
  protection: true,
  modelNumberLocation: true,
  callUsSupport: true,
  applianceCareTermAndConditions: true,
  errorPageCallUs: true,
  productDetails: true,
  loadingPhoneUs: true,
};

export const resolveTenantFeatures = (overrides?: TenantFeatureOverrides): TenantFeatures => ({
  ...defaultTenantFeatures,
  ...overrides,
});
